import CustomDialog from "../../common/CustomDialog";
import FormField from "../../common/FormField";
import CustomButton from "../../common/CustomButton";
import SelectField from "../../common/SelectField";
import FormCheckbox from "../../common/FormCheckbox";

export default function AddAdminGroup({
  open,
  onHandleClose,
  formData,
  handleChange,
  handleSubmit,
  isSubmitting,
  formErrors,
  isEditing,
}) {
  const fields = [
    { label: "Created By", name: "createdBy", type: "text" },
    { label: "Group Chat ID", name: "groupChatId", type: "text" },
    { label: "Group Description", name: "groupDescription", type: "text" },
    { label: "Group Name", name: "groupName", type: "text" },
    // { label: "Group Type", name: "groupType", type: "text" },
  ];
  console.log(formData)
  // Handles pressing Enter to submit from any field
  const handleKeyDown = (e) => {
    try {
      if (e?.key === "Enter" && e?.target?.type !== "textarea") {
        e?.preventDefault();
        handleSubmit(e);
      }
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  const title = isEditing ? "Edit Admin Group" : "Add Admin Group";
  const visibleFields = isEditing
    ? fields.filter((f) => !["mid", "createdBy"].includes(f.name))
    : fields;

  return (
    <>
      <CustomDialog
        open={open}
        onClose={onHandleClose}
        title={title}
        actions={
          <>
            <CustomButton
              variant="outlined"
              label="Cancel"
              onClick={onHandleClose}
            />
            <CustomButton
              variant="contained"
              label={isSubmitting ? "Saving..." : title}
              type="submit"
              disabled={isSubmitting}
              loading={isSubmitting}
              onClick={handleSubmit}
            />
          </>
        }
      >
        <div className="row">
          {visibleFields?.map((f, i) => (
            <div
              className={`${f.type === "checkbox"
                ? "col-12 d-flex align-items-center mt-2"
                : "col-12 col-md-6"
                }`}
              key={i}
            >
              {/* // <div className="col-12 col-md-6" key={i}> */}
              {f?.type === "select" ? (
                <SelectField
                  label={f?.label}
                  name={f?.name}
                  value={formData[f?.name] || ""}
                  onChange={handleChange}
                  required
                  options={f?.options}
                  error={formErrors?.[f?.name]}
                />
              ) : f?.type === "checkbox" ? (
                <FormCheckbox
                  label={f?.label}
                  name={f?.name}
                  checked={formData[f?.name]}
                  onChange={handleChange}
                />
              ) : (
                <FormField
                  label={f?.label}
                  name={f?.name}
                  type={f?.type}
                  value={formData[f?.name] || ""}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  placeholder={`Enter ${f?.label}`}
                  required
                  error={formErrors?.[f?.name]}
                />
              )}
            </div>
          ))}
          <FormField
            label={"Group Type"}
            name={"groupType"}
            type={"text"}
            value={formData["groupType"] || ""}
            onChange={(e) => {
              const input = e?.target?.value?.toUpperCase()?.trimStart(); // ✅ uppercase + trim start
              const isValid = /^[A-Za-z ]*$/.test(input); // ✅ letters + spaces only
              if (isValid) {
                handleChange({
                  target: { name: "groupType", value: input },
                }); // ✅ update correct key
              }
            }}
            onKeyDown={handleKeyDown}
            placeholder={`Enter ${"Group Type"}`}
            required
            error={formErrors?.["groupType"]}
          />
        </div>
      </CustomDialog>
    </>
  );
}














// import CustomDialog from "../../common/CustomDialog";
// import FormField from "../../common/FormField";
// import CustomButton from "../../common/CustomButton";
// import SelectField from "../../common/SelectField";
// import FormCheckbox from "../../common/FormCheckbox";

// export default function AddAdminGroup({
//   open,
//   onHandleClose,
//   formData,
//   handleChange,
//   handleSubmit,
//   isSubmitting,
//   formErrors,
//   isEditing,
// }) {
//   const fields = [
//     { label: "Created By", name: "createdBy", type: "text" },
//     { label: "Group Chat ID", name: "groupChatId", type: "text" },
//     { label: "Group Description", name: "groupDescription", type: "text" },
//     { label: "Group Name", name: "groupName", type: "text" },
//     // { label: "Group Type", name: "groupType", type: "text" },
//   ];

//   // Handles pressing Enter to submit from any field
//   const handleKeyDown = (e) => {
//     try {
//       if (e?.key === "Enter" && e?.target?.type !== "textarea") {
//         e?.preventDefault();
//         handleSubmit(e);
//       }
//     } catch (error) {
//       console.log(`Error: ${error}`);
//     }
//   };

//   const title = isEditing ? "Edit Admin Group" : "Add Admin Group";
//   const visibleFields = isEditing
//     ? fields.filter((f) => !["mid", "createdBy"].includes(f.name))
//     : fields;

//   return (
//     <>
//       <CustomDialog
//         open={open}
//         onClose={onHandleClose}
//         title={title}
//         actions={
//           <>
//             <CustomButton
//               variant="outlined"
//               label="Cancel"
//               onClick={onHandleClose}
//             />
//             <CustomButton
//               variant="contained"
//               label={isSubmitting ? "Saving..." : title}
//               type="submit"
//               disabled={isSubmitting}
//               loading={isSubmitting}
//               onClick={handleSubmit}
//             />
//           </>
//         }
//       >
//         <div className="row">
//           {visibleFields?.map((f, i) => (
//             <div
//               className={`${
//                 f.type === "checkbox"
//                   ? "col-12 d-flex align-items-center mt-2"
//                   : "col-12 col-md-6"
//               }`}
//               key={i}
//             >
//               {/* // <div className="col-12 col-md-6" key={i}> */}
//               {f?.type === "select" ? (
//                 <SelectField
//                   label={f?.label}
//                   name={f?.name}
//                   value={formData[f?.name] || ""}
//                   onChange={handleChange}
//                   required
//                   options={f?.options}
//                   error={formErrors?.[f?.name]}
//                 />
//               ) : f?.type === "checkbox" ? (
//                 <FormCheckbox
//                   label={f?.label}
//                   name={f?.name}
//                   checked={formData[f?.name]}
//                   onChange={handleChange}
//                 />
//               ) : (
//                 <FormField
//                   label={f?.label}
//                   name={f?.name}
//                   type={f?.type}
//                   value={formData[f?.name] || ""}
//                   onChange={handleChange}
//                   onKeyDown={handleKeyDown}
//                   placeholder={`Enter ${f?.label}`}
//                   required
//                   error={formErrors?.[f?.name]}
//                 />
//               )}
//             </div>
//           ))}
//           <FormField
//             label={"Group Type"}
//             name={"groupType"}
//             type={"text"}
//             value={formData["groupType"] || ""}
//             onChange={(e) => {
//               const input = e?.target?.value?.toUpperCase()?.trimStart(); // ✅ uppercase + trim start
//               const isValid = /^[A-Za-z ]*$/.test(input); // ✅ letters + spaces only
//               if (isValid) {
//                 handleChange({
//                   target: { name: "groupType", value: input },
//                 }); // ✅ update correct key
//               }
//             }}
//             onKeyDown={handleKeyDown}
//             placeholder={`Enter ${"Group Type"}`}
//             required
//             error={formErrors?.["groupType"]}
//           />
//         </div>
//       </CustomDialog>
//     </>
//   );
// }
